import $ from "jquery";

$(function () {
    // Display more or fewer publications
    function updatePubsBlock(change, triggerButton) {
        const container = triggerButton.closest('.publications-block-container');
        const showMoreButton = container.find('.pubs-show-more');
        const showLessButton = container.find('.pubs-show-less');
        const showingCount = container.find('.pubs-showing-count');
        const data = showingCount.data();

        // Update current value
        data.current += change;
        data.current = Math.max(data.min, Math.min(data.current, data.max)); // Ensure current is within bounds

        // Update data attribute and display count
        showingCount.data('current', data.current);
        showingCount.text(data.current);

        // Update Show More/Show Less button visibility
        showLessButton.toggleClass('d-none', data.current === data.min);
        showMoreButton.toggleClass('d-none', data.current === data.max);

        // Show or hide publication rows
        container.find('li').each(function (index) {
            const row = $(this);
            const rowNum = row.data('row');
            if (rowNum <= data.current) {
                row.removeClass('pubs-hidden');
            } else {
                row.addClass('pubs-hidden');
            }
        });
    }

    // Show more button click event
    $('body').on('click', '.pubs-show-more', function () {
        updatePubsBlock(10, $(this));
    });

    // Show less button click event
    $('body').on('click', '.pubs-show-less', function () {
        updatePubsBlock(-10, $(this));
    });
});